import React from 'react';

import DashWellcome from '../../../Components/DashComponents/DashWellcome';

const Dashboard = () => {
    return (
      <div className="flex-1 p-20 w-full">
        <DashWellcome className=" "></DashWellcome>
      </div>
    );
};

export default Dashboard;